import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { Eye, LogOut } from 'lucide-react';

/**
 * ImpersonationBanner — Admin "Ogrenci Gibi Gir" ile acilan SEKMEYE OZEL oturumda
 * (sessionStorage token) gorunur ince ust-bant. Normal ogrenci oturumunda
 * (localStorage) render EDILMEZ.
 *
 * Cikis: bu sekmenin sessionStorage token'ini temizler (admin'in localStorage
 * oturumunu SILMEZ) ve /login'e gider.
 */
export default function ImpersonationBanner() {
  const { isImpersonating, logout } = useAuth();
  const { lang } = useLanguage();
  const tr = (t, e) => (lang === 'tr' ? t : e);

  if (!isImpersonating) return null;

  const handleExit = async () => {
    await logout();
    // Sekmeye ozel oturum temizlendi; giris sayfasina don.
    window.location.replace('/login');
  };

  return (
    <div
      role="status"
      aria-live="polite"
      className="sticky top-0 z-30 flex items-center justify-center gap-3 px-4 py-2 text-sm font-bold text-white"
      style={{
        backgroundColor: 'var(--duo-orange)',
        boxShadow: '0 2px 0 0 var(--duo-orange-dark)',
      }}
      data-testid="impersonation-banner"
    >
      <Eye size={16} strokeWidth={2.5} aria-hidden="true" />
      <span>
        {tr('Öğrenci olarak görüntülüyorsunuz', 'Viewing as student')}
      </span>
      <button
        type="button"
        onClick={handleExit}
        className="inline-flex items-center gap-1 rounded-full bg-white/20 px-3 py-1 font-bold transition-colors hover:bg-white/30 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
        data-testid="impersonation-exit-btn"
      >
        <LogOut size={14} strokeWidth={2.5} aria-hidden="true" />
        {tr('Çıkış', 'Exit')}
      </button>
    </div>
  );
}
